const AdInjector = {
  init() {
    window.googletag = window.googletag || { cmd: [] };
    
  if (window.Cookiebot) {
    this.setupLazyLoading();
  } else {
    window.addEventListener('CookiebotOnLoad', () => {
      this.setupLazyLoading();
  });
}

  },

  setupLazyLoading() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.loadAdForContainer(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, {
      rootMargin: '300px' // Start loading 300px before ad comes into view
    });

    // Observe all ad containers
    this.adList.forEach(ad => {
      const containers = document.getElementsByClassName(ad.targetContainer);
      Array.from(containers).forEach(container => {
        observer.observe(container);
      });
    });
  },

  async loadAdForContainer(container) {
    if (!window.googletag || !window.googletag.apiReady) {
      await this.loadGPTScript();
      this.adsBlocked = this.clientHasAdblocker();
    }

    if (this.adsBlocked){
      this.showPlaceholders();
    } 
    
    this.setupAdForContainer(container);
  },

  loadGPTScript() {
    return new Promise((resolve) => {
      if (window.googletag && window.googletag.apiReady) {
        resolve();
        return;
      }

      const gptScript = document.createElement("script");
      gptScript.async = true;
      gptScript.src = "https://securepubads.g.doubleclick.net/tag/js/gpt.js";
      gptScript.onload = () => {
        googletag.cmd.push(() => {
          googletag.pubads().enableSingleRequest();
          googletag.pubads().collapseEmptyDivs(true);
          googletag.pubads().enableLazyLoad({
            fetchMarginPercent: 200, 
            renderMarginPercent: 50,
            mobileScaling: 2.0
          });
          googletag.enableServices();
          resolve();
        });
      };

    gptScript.onerror = (error) => {
      this.adsBlocked = true;
      resolve();
    };
    
      document.head.appendChild(gptScript);
    });
  },

  setupAdForContainer(container) {
    // Find which ad config this container belongs to
    const adConfig = this.adList.find(ad => 
      container.classList.contains(ad.targetContainer)
    );
    
    if (!adConfig) return;

    // Prepare container if not already done
    this.prepareContainer(container, adConfig);

    googletag.cmd.push(() => {
      const adContent = container.querySelector('.ad-content');
      if (!adContent) return;

      const mappingBuilder = googletag.sizeMapping();
      adConfig.sizes?.forEach(sizeRule => {
        mappingBuilder.addSize(sizeRule.viewport, sizeRule.sizes);
      });
      const sizeMapping = mappingBuilder.build();
      const allSizes = adConfig.sizes.map(sizeRule => sizeRule.sizes).flat();

      googletag.defineSlot(adConfig.slotName, allSizes, adContent.id)
        .defineSizeMapping(sizeMapping)
        .addService(googletag.pubads());

      googletag.display(adContent.id);
    });
  },

  prepareContainer(container, adConfig) {
    const containerIndex = Array.from(document.getElementsByClassName(adConfig.targetContainer)).indexOf(container);
    const adDiv = document.getElementById(adConfig.ID + '-' + containerIndex);
    
    if (!adDiv) {
      const newAdDiv = document.createElement('div');
      newAdDiv.id = adConfig.ID + '-' + containerIndex;
      newAdDiv.classList.add('ad-content');
      container.appendChild(newAdDiv);
    }
  },

  clientHasAdblocker() {
    	const scripts = document.head.querySelectorAll('script');
	
      for (let script of scripts) {
        if (script.src && script.src.includes('pubads_impl.js')) {
          return false;
        }
      }
      return true;
  },

  showPlaceholders() {
    const adContainersList = this.adList.map(ad => ad.targetContainer);
    const fallbacksURL = touchitData.theme_url + '/assets/images/ad-fallbacks/';
    const placeholderSizesMap = {
      '300x150': fallbacksURL + '2-1.webp',
      '1240x250': fallbacksURL + '5-1.webp',
      '300x600': fallbacksURL + '1-1.webp',
      '728x90': fallbacksURL + '5-1.webp',
      '300x300': fallbacksURL + '1-1.webp',
      '300x250': fallbacksURL + '1-1.webp',
    };
    
    adContainersList.forEach(containerClass => {
      const containers = document.getElementsByClassName(containerClass);
      let placeholderURL = fallbacksURL + 'default.webp';

      for (const sizeKey in placeholderSizesMap) {
        if (containerClass.includes(sizeKey)) {
          placeholderURL = placeholderSizesMap[sizeKey];
          break;
        }
      }

      Array.from(containers).forEach(container => {
        container.innerHTML = `<img src="${placeholderURL}" class="touchit-ads-placeholder" alt="Tu mala byť reklama"/>`;
      });
    });
  },

adList: [
  {
    slotName: "/130791087/REDIZAJNOVANY-FEED-300x150-2M",
    ID: "div-gpt-ad-1762253031226",
    sizes: [
      { viewport: [0, 0], sizes: [300, 150] }
    ],
    targetContainer: "touchit-ad-300x150-top",
  },
  {
    slotName: "/130791087/REDIZAJNOVANY",
    ID: "div-gpt-ad-1762252926971",
    sizes: [
      { viewport: [0, 0], sizes: [1240, 250] },
    ],
    targetContainer: "touchit-ad-1240x250",
  },
  {
    slotName: "/130791087/REDIZAJN-300x600",
    ID: "div-gpt-ad-1752058598351",
    sizes: [
      { viewport: [0, 0], sizes: [[300, 250], [300, 300], [300, 600]] }
    ],
    targetContainer: "touchit-ad-300x600",
  },
  {
    slotName: "/130791087/REDIZAJNOVANY-300x600-2D",
    ID: "div-gpt-ad-1752058678960",
    sizes: [
      { viewport: [0, 0], sizes: [[300, 300], [300, 600], [300, 250]] }
    ],
    targetContainer: "touchit-ad-300x600-1",
  },
  {
    slotName: "/130791087/REDIZAJNOVANY-TELO-1",
    ID: "div-gpt-ad-1752058251525",
    sizes: [
      { viewport: [1024, 0], sizes: [728, 90] },
      { viewport: [0, 0], sizes: [300, 250] } 
    ],
    targetContainer: "touchit-ad-728x90",
  },
  {
    slotName: "/130791087/REDIZAJNOVANY-TELO-2",
    ID: "div-gpt-ad-1752058321263",
    sizes: [
      { viewport: [1024, 0], sizes: [728, 90] },
      { viewport: [0, 0], sizes: [300, 250] } 
    ],
    targetContainer: "touchit-ad-728x90-1",
  },
    {
    slotName: "/130791087/REDIZAJNOVANY-FEED-3",
    ID: "div-gpt-ad-1752058379409",
    sizes: [
      { viewport: [1024, 0], sizes: [728, 90] },
      { viewport: [0, 0], sizes: [300, 250] } 
    ],
    targetContainer: "touchit-ad-728x90-feed",
  },
  {
    slotName: "/130791087/REDIZJAN-300x300",
    ID: "div-gpt-ad-1741616693974",
    sizes: [
      { viewport: [0, 0], sizes: [300, 300] }
    ],
    targetContainer: "touchit-ad-300x300",
  },
  {
    slotName: "/130791087/REDIZAJNOVANY-FEED-300x250-1M",
    ID: "div-gpt-ad-1762253287642",
    sizes: [
      { viewport: [0, 0], sizes: [[300, 250], [300, 600], [300, 300]] }
    ],
    targetContainer: "touchit-ad-300x250",
  },
  {
    slotName: "/130791087/REDIZAJNOVANY-FEED-300x150-2M",
    ID: "div-gpt-ad-1752060570708",
    sizes: [
      { viewport: [0, 0], sizes: [300, 150] }
    ],
    targetContainer: "touchit-ad-300x150",
  },
  {
    slotName: "/130791087/REDIZAJNOVANY-FEED-300x150-3M",
    ID: "div-gpt-ad-1762253384530",
    sizes: [
      { viewport: [0, 0], sizes: [[300, 250], [300, 300], [300, 600], [300, 150]] }
    ],
    targetContainer: "touchit-ad-300x150-1",
  },
  {
    slotName: "/130791087/REDIZAJNOVANY-FEED-300x150-4M",
    ID: "div-gpt-ad-1762253466651",
    sizes: [
      { viewport: [0, 0], sizes: [[300, 600], [300, 300], [300, 150], [300, 250]] }
    ],
    targetContainer: "touchit-ad-300x150-2",
  },
  // BRANDIT ads
  {
    slotName: "/130791087/REDIZAJNOVANY",
    ID: "div-gpt-ad-1762252926971",
    sizes: [
      { viewport: [0, 0], sizes: [1240, 250] }
    ],
    targetContainer: "touchit-ad-1240x250-top-brandit",
  },
  {
    slotName: "/130791087/REDIZAJNOVANY-FEED-300x150-2M",
    ID: "div-gpt-ad-1762253031226",
    sizes: [
      { viewport: [0, 0], sizes: [300, 150] }
    ],
    targetContainer: "touchit-ad-300x150-top-brandit",
  },
],

  
  refreshAds() {
    googletag.cmd.push(() => {
      googletag.pubads().refresh();
    });
  }
};

export default AdInjector;